module.exports = "<div class=rm-step-responsiblity><div ag-grid=gridOptions ui-grid-auto-resize=\"\" ng-style={height:height} class=ag-fresh></div></div>";